/* eslint-disable no-undef */

import { html, LitElement } from 'lit';

export class IconMessagesActive extends LitElement {
    render() {
        return html`
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <title>Messages</title>
                <path
                    d="M21.75 18.75H11.25L5.25 23.25V18.75H2.25C1.85218 18.75 1.47064 18.592 1.18934 18.3107C0.908035 18.0294 0.75 17.6478 0.75 17.25V2.25C0.75 1.85218 0.908035 1.47064 1.18934 1.18934C1.47064 0.908035 1.85218 0.75 2.25 0.75H21.75C22.1478 0.75 22.5294 0.908035 22.8107 1.18934C23.092 1.47064 23.25 1.85218 23.25 2.25V17.25C23.25 17.6478 23.092 18.0294 22.8107 18.3107C22.5294 18.592 22.1478 18.75 21.75 18.75Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M9.62214 7.22804C9.43768 6.86274 9.15637 6.55494 8.80874 6.33841C8.45418 6.11756 8.04481 6.00049 7.62708 6.00049C7.20935 6.00049 6.79999 6.11756 6.44542 6.33841C6.09779 6.55494 5.81648 6.86274 5.63202 7.22804"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M14.6265 7.22737C14.811 6.86236 15.0922 6.55481 15.4396 6.33841C15.7942 6.11756 16.2035 6.00049 16.6212 6.00049C17.039 6.00049 17.4483 6.11756 17.8029 6.33841C18.1503 6.55481 18.4315 6.86236 18.616 7.22737"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M17.5 12C16.5 13.5 15.3988 14.2004 14.5 14.5C13.6012 14.7996 12 15 10.5 14.5"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        `;
    }
}
if (!customElements.get('icon-messages-active24')) {
    customElements.define('icon-messages-active24', IconMessagesActive);
}
